import SimplePageHeader from "@components/SimplePageHeader";
import itemsGridItemStyles from "@components/ItemsGrid/ItemsGridItem/style.module.scss";
import itemsGridStyles from "@components/ItemsGrid/style.module.scss";
import Spring from "@components/Spring";
import Title from "@components/Title";
import { Typography } from "@mui/material";
import api from "@utils/api";
import React, { lazy, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import GradientBtn from "@ui/GradientBtn";
import { PDFDownloadLink } from "@react-pdf/renderer";
import ComicPDF from "@components/ComicPDF";

const Comic = () => {
  const token = localStorage.getItem("token");
  const [comicPages, setComicPages] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [comicName, setComicName] = useState();
  const [comicId, setComicId] = useState();
  const [comicImages, setComicImages] = useState();
  const params = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const headers = { Authorization: `Bearer ${token}` };
    api
      .get("/list-comic-book-page", {
        headers,
        params: {
          comic: params.id,
        },
      })
      .then((res) => {
        let comicPagesData = res?.data?.data;
        setComicPages(comicPagesData);
        setPageNumber(comicPagesData.length + 1);
        setComicImages(comicPagesData.map((page) => page.page_image));
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // console.log(comicImages);

  useEffect(() => {
    const headers = { Authorization: `Bearer ${token}` };
    api
      .get("/comic-book-list", { headers })
      .then((res) => {
        const comics = res?.data?.data;
        const filteredComic = comics.find(
          (comic) => comic.id.toString() === params.id
        ); // Assuming 'id' is the parameter you want to filter with
        if (filteredComic) {
          setComicId(filteredComic.id);
          setComicName(filteredComic.title);
        } else {
          // Handle case when no comic is found with the provided ID
          console.log("No comic found with the provided ID");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  console.log(comicPages);

  return (
    <div>
      <Title title="Comic" />
      <SimplePageHeader title="Comic" />

      <div style={{ marginInline: "20px" }}>
        <div className="d-flex justify-content-end g-10">
          {/* Create a new comic */}
          <button
            className="btn btn--outline"
            onClick={() =>
              navigate(`/creation/${params?.id}/create/${pageNumber}`)
            }
          >
            Create Page
          </button>
          <PDFDownloadLink
            document={<ComicPDF images={comicImages} name={comicName} />}
            fileName={`${comicName}`}
          >
            {({ loading }) =>
              loading ? (
                <GradientBtn tag="button" type="submit">
                  Loading
                </GradientBtn>
              ) : (
                <GradientBtn tag="button" type="submit">
                  Download PDF
                </GradientBtn>
              )
            }
          </PDFDownloadLink>
        </div>
        {comicPages.length !== 0 ? (
          <Swiper
            spaceBetween={50}
            slidesPerView={4}
            navigation={true}
            modules={[Navigation]}
            breakpoints={{
              0: {
                slidesPerView: 1,
                spaceBetween: 0,
              },
              400: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
              575: {
                slidesPerView: 3,
                spaceBetween: 18,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 40,
              },
              1440: {
                slidesPerView: 4,
                spaceBetween: 50,
              },
            }}
            onSlideChange={() => console.log("slide change")}
            onSwiper={(swiper) => console.log(swiper)}
            className="slider-custom-icon"
          >
            {comicPages.map((page, index) => {
              return (
                <SwiperSlide
                  // onClick={() => navigate(`/c/${page?.id}`)}
                  onClick={() =>
                    navigate(`/creation/${comicId}/edit/${page.page_number}`)
                  }
                  style={{ paddingTop: "100px", cursor: "pointer" }}
                >
                  <Spring key={index}>
                    <div
                      className={` border-hover bg-primary `}
                      style={{ padding: "15px" }}
                    >
                      <div style={{ background: "white" }}>
                        <div
                          className="d-flex flex-column justify-content-center"
                          style={{ height: "100%" }}
                        >
                          {/* <Typography className="d-flex align-items-center justify-content-center text-bold">
                          {comic?.title}
                        </Typography> */}
                          {/* <Typography
                            className="d-flex align-items-center justify-content-center"
                            style={{
                              fontWeight: "1000",
                              color: "black",
                              fontSize: "1.5rem",
                            }}
                          >
                            {page?.page_image}
                          </Typography> */}
                          <img
                             src={page?.page_image}
                           // src={`http://127.0.0.1:8000${page?.page_image}`}
                            alt="pageImage"
                          ></img>
                          {/* <Typography
                          className="d-flex align-items-center justify-content-center"
                          style={{
                              fontWeight: "1000",
                              color: "black",
                              fontSize: "1.5rem",
                            }}
                        ></Typography> */}
                        </div>
                      </div>
                    </div>
                  </Spring>
                </SwiperSlide>
              );
            })}
          </Swiper>
        ) : (
          <Typography className="d-flex align-items-center">
            This comic doesn't have any pages.
          </Typography>
        )}
      </div>
    </div>
  );
};

export default Comic;
